import { render } from "./Alergenos.vue?vue&type=template&id=36775aa5"
import script from "./Alergenos.vue?vue&type=script&lang=js"
export * from "./Alergenos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__